<ul class="router-tab-items">
    <ng-content></ng-content>
</ul>

<router-outlet></router-outlet>